export const PERFORMANCE_REPORT_LOADING = "PERFORMANCE_REPORT_LOADING";
export const PERFORMANCE_REPORT_SUCCESS = "PERFORMANCE_REPORT_SUCCESS";
export const PERFORMANCE_REPORT_FAILED = "PERFORMANCE_REPORT_FAILED";
export const PERFORMANCE_REPORT_LIST_LOADING =
  "PERFORMANCE_REPORT_LIST_LOADING";
export const PERFORMANCE_REPORT_LIST_SUCCESS =
  "PERFORMANCE_REPORT_LIST_SUCCESS";
export const PERFORMANCE_REPORT_LIST_FAILED = "PERFORMANCE_REPORT_LIST_FAILED";
export const TOGGLE_PERFORMANCE_DRAWER_VISIBILITY =
  "TOGGLE_PERFORMANCE_DRAWER_VISIBILITY";
export const RESET_PERFORMANCE_REPORT = "RESET_PERFORMANCE_REPORT";
export const PERFORMANCE_REPORT_SUCCESS_NEW_PRIMER =
  "PERFORMANCE_REPORT_SUCCESS_NEW_PRIMER";
export const RESET_PERFORMANCE_REPORT_NEW_PRIMER =
  "RESET_PERFORMANCE_REPORT_NEW_PRIMER";
